/** Service fee stored in `totalCost` (deposit is separate on `depositAmount`). */
export function resolveUtilityBookingServiceFee(booking: {
  totalCost?: number | null;
  depositAmount?: number | null;
}): number {
  const total = booking.totalCost ?? 0;
  const deposit = booking.depositAmount ?? 0;

  if (deposit <= 0) {
    return total;
  }

  // Legacy rows: totalCost included deposit or was set equal to deposit.
  if (total === deposit || total === deposit * 2) {
    return 0;
  }

  if (total > deposit) {
    return total - deposit;
  }

  return total;
}

export function resolveUtilityBookingPaymentTotal(booking: {
  totalCost?: number | null;
  depositAmount?: number | null;
}): number {
  const service = resolveUtilityBookingServiceFee(booking);
  const deposit = booking.depositAmount ?? 0;
  return service + deposit;
}

/** Counter collection is service fee when there is no deposit on the booking. */
export function isUtilityBookingServiceFeeCollection(booking: {
  totalCost?: number | null;
  depositAmount?: number | null;
}): boolean {
  if ((booking.depositAmount ?? 0) > 0) {
    return false;
  }
  return resolveUtilityBookingServiceFee(booking) > 0;
}
